import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { EventsInfo } from 'src/app/Models/MisEventos/eventsInfo';

@Component({
  selector: 'app-resumen-eventos',
  templateUrl: './resumen-eventos.component.html',
  styleUrls: ['./resumen-eventos.component.css']
})
export class ResumenEventosComponent implements OnInit {

  @Input()
  resumenEventos: EventsInfo;

  constructor() { }

  ngOnInit(): void {

  }

}
